import React, { PureComponent } from "react";
import styled from "styled-components";
import { ICSS, ICSSProps, Icon, ColorProps, Color, GlobalColorPalette } from "@gago/frame";
import { message } from "antd";
import tinycolor from "tinycolor2";
import moment from "moment";
import { isEqual } from "lodash";
// tslint:disable:ter-max-len
// tslint:disable:triple-equals
// tslint:disable:variable-name
// tslint:disable:jsx-no-multiline-js
// tslint:disable:early-exit
const InputTimelineBody = styled.div<{colorPalette: GlobalColorPalette}>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 56px;
  padding-right: 16px;
  border-radius: 8px;
  border: solid 1px rgb(0 202 224 / 60%);
  .item-box{
    margin: 0 auto;
    width: 80px;
    height: 28px;
    border-radius: 30px;
    font-size: 14px;
    font-weight: 300;
    color: #00cae0;
    line-height: 28px;
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;
  }
  .active{
    font-weight: 500;
    color: #c2fffa;
    box-shadow: 0 0 0 2px #c2fffa;
  }
  .play-box{
    width: 80px;
    height: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    .play-border{
      height: 22px;
      width: 22px;
      background-color: #c2fffa;
      border-radius: 50%;
      overflow: hidden;
      cursor: pointer;
      text-align: center;
      line-height: 22px;
      font-size: 16px;
    }
  }
`;
type Props= {
  /** 时间格式 */
  dateFormat?: string;
  /** 默认展示序号 */
  defaultSelect?: number;
  /** 时间轴显示的时间格式，数组 */
  data: string[];
  /** 时间轴触发回调 */
  onChange(data: string): void;
} & ICSSProps & ColorProps<GlobalColorPalette>;
interface State {
  /** 展示时间轴数据的序号 */
  serialNumber: number;
  /** 播放状态 */
  player: boolean;
}

/**
 * 时间轴 - 风险地图页面
 *
 * @author 马俊峰
 * @date 2019-07-30
 * @export
 * @class InputTimeline
 * @extends {PureComponent<Props, State>}
 * @implements {ICSS}
 * @implements {Color}
 */
export class InputTimeline extends PureComponent<Props, State> implements ICSS, Color {
  /** 定义计时器事件 */
  clearTime: number | undefined;
  state: State = {
    serialNumber: 0,
    player: false,
  };
  componentDidMount() {
    const { data, defaultSelect } = this.props;
    if (defaultSelect) { this.setState({ serialNumber: defaultSelect }); }
    // this.props.onChange && this.props.onChange(data[0]);
  }
  componentDidUpdate(preProps: Props) {
    if (!isEqual(preProps.data, this.props.data)) {
      this.setState({ serialNumber: 0 }, () => { this.props.onChange && this.props.onChange(this.props.data[0]); });
    }
  }
  render() {
    const { player, serialNumber } = this.state;
    const { data, style, className, colorPalette, dateFormat } = this.props;
    return(
      <InputTimelineBody style={style} className={className} colorPalette={colorPalette}>
        <div className="play-box">
          <span className="play-border" onClick={player ? this.pauseClick : this.palyerClick}>{player ? <Icon>pause</Icon> : <Icon>play</Icon>}</span>
        </div>
        {data.map((item: string, index: number) => (
          <div className={`item-box ${serialNumber === index && "active"}`} key={index} onClick={this.selectClick.bind(this, item, index)}>{dateFormat ? moment(item).format(dateFormat) : item}</div>
        ))}
      </InputTimelineBody>
    );
  }
  /** 播放按钮点击事件 */
  palyerClick = () => {
    const { data } = this.props;
    if (data.length < 1) { message.info("您还未传入数据，不可播放", 1); return; }
    this.judgeStartCarousel(true);
    this.setState({ player: true });
  }
  /** 暂停按钮点击事件 */
  pauseClick = () => {
    this.judgeStartCarousel(false);
    this.setState({ player: false });
  }
  /** 列表图标，点击事件 */
  selectClick = (item: string, index: number) => {
    this.setState({ serialNumber: index, player: false });
    this.clearTime && window.clearInterval(this.clearTime);
    this.props.onChange && this.props.onChange(item);
  }
  /** 是否开始进行轮播展示，时间轴 */
  judgeStartCarousel = (player: boolean) => {
    this.clearTime && window.clearInterval(this.clearTime);
    if (player) {
      const { data } = this.props;
      this.clearTime = setInterval(() => {
        let num: number = this.state.serialNumber + 1;
        if (num >= data.length) { num = 0; }
        this.setState({ serialNumber: num });
        this.props.onChange && this.props.onChange(data[num]);
      }, 4000);
    }
  }
  componentWillUnmount() {
    this.clearTime && window.clearInterval(this.clearTime);
  }
}
